import { conditions } from "helpers";
import { ConditionName, ILiveStatusProps, zIndex } from "interfaces";
import { handleIsLive } from "redux-share/actions/controller.actions";
import LiveIcon from "./onlineViewer/liveIcon";
import { useAppSelector } from "redux-share";
import { shallowEqual } from 'react-redux';
import dynamic from "next/dynamic";

const OnlineViewer = dynamic(() => import("./onlineViewer/onlineViewer"));

const LiveStatus = ({ className }: ILiveStatusProps) => {

    useAppSelector(({ videoData: { isComplexPortrait, isComplexDesktop, onlineViewers, details } }) => ({ isComplexPortrait, isComplexDesktop, onlineViewers, details }), shallowEqual);
    useAppSelector(({ controller: { isLive } }) => ({ isLive }), shallowEqual);

    return (
        <div 
            style={{ zIndex: conditions(ConditionName.isComplexPortrait) ? 0 : zIndex.liveStatus }}
            className={`pl-flex pl-max-w-max pl-gap-1 pl-items-center pl-rounded pl-p-1.5 ${!conditions(ConditionName.isComplexPortrait) && "pl-relative"} ${conditions(ConditionName.isLive) ? "pl-bg-red-zProgress pl-cursor-default" : "pl-bg-z-gray-500 pl-cursor-pointer"} ${className}`}
            onClick={() => !conditions(ConditionName.isLive) && handleIsLive()}
        >
            <div className={`pl-flex pl-items-center pl-gap-2`}>
                <LiveIcon isLive={conditions(ConditionName.isLive)}/>
                <p className="pl-text-white pl-text-[12px] pl-font-medium">زنده</p>
            </div>
            {conditions(ConditionName.showOnlineViewers) && conditions(ConditionName.thresholdOnlineViewers) &&
                <>
                    <div className="pl-w-[1px] pl-h-[14px] pl-bg-white"></div>
                    <OnlineViewer />
                </>
            }
        </div>
    )
}

export default LiveStatus;